import React from 'react';
import {useSelector} from 'react-redux';

const defaultRoleTitles = ['admin', 'editor', 'manager', 'seller'];
export default ({
  item,
  calculatePositionOfStickyHeaders,
  config,
  index,
  roleTitles,
}) => {
  const roles = useSelector((state) => state.roles.roles);
  const titles =
    roleTitles ||
    roles
      .filter((role) => defaultRoleTitles.includes(role.title))
      .map((role) => role.title)
      .reverse();
  const assigned =
    (roleTitles && item.accountRoles) ||
    roles
      .filter((role) => item.roles?.some((r) => (r?._id || r) === role._id))
      .map((role) => role.title);
  return (
    <td
      className={`text-center p-0 ${index === 0 ? 'first-cell' : ''}`}
      style={{
        ...calculatePositionOfStickyHeaders(config),
        verticalAlign: 'middle',
      }}
    >
      <div className="overview-cell d-flex align-items-center justify-content-center">
        {titles.map((title) => (
          <div
            key={title}
            className={`d-flex justify-content-center align-items-center py-1 ${
              assigned.includes(title) ? 'user-has-role' : ''
            }`}
          >
            <span>{title.capitalize()}</span>
          </div>
        ))}
      </div>
    </td>
  );
};
